import { render, staticRenderFns } from "./DongguanMobileElm01.vue?vue&type=template&id=0fc5df54&scoped=true"
import script from "./DongguanMobileElm01.vue?vue&type=script&lang=js"
export * from "./DongguanMobileElm01.vue?vue&type=script&lang=js"
import style0 from "./DongguanMobileElm01.vue?vue&type=style&index=0&id=0fc5df54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5df54",
  null
  
)

export default component.exports